import './index.css';

import * as moment from 'moment';
import * as React from 'react';
import { connect } from 'react-redux';
import Utility from 'src/common/Utility';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';

import {
  destroyMemo,
  readMemo,
  readMemosByDeadline,
  truncateMemos,
  updateMemo,
  updateMemos
} from '../../actions/memo';
import Memo from '../../entities/Memo';
import Cancel from '../../res/img/cancel_gray.svg';
import Navigation from '../Navigation/global';
import MemoItem from './item';
import OtherActions from './otherActions';

interface IProps {
  account: Member;
  groups: Group[];
  memos: Memo[];
  allMemos: Memo[];
  members: Member[];
  readMemo: (memo: Memo) => void;
  updateMemo: (memo: Memo) => void;
  updateMemos: (memo: Memo[]) => void;
  destroyMemo: (memo: Memo) => void;

  readMemosByDeadline: (deadline: number) => void;
  truncateMemos: () => void;
}

interface IState {
  doesShowPopup: boolean;
  popupMemoId: number;
  loadedApis: number[];
  deadline: number;
}

class MemoComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      doesShowPopup: false,
      popupMemoId: 0,
      loadedApis: [],
      deadline:
        1000 *
        moment()
          .hour(0)
          .minute(0)
          .second(0)
          .unix()
    };

    this.showPopup = this.showPopup.bind(this);
    this.hidePopup = this.hidePopup.bind(this);
    this.onChangeDeadline = this.onChangeDeadline.bind(this);
  }

  componentWillMount() {
    this.props.truncateMemos();
    this.props.readMemosByDeadline(this.state.deadline);
  }

  componentDidMount() {
    // popup指定
    if (location.hash.includes('popup')) {
      const memoId = Number(location.hash.split('=')[1]);
      this.showPopup(memoId);
    }
  }

  render() {
    const memos = this.props.memos.sort((a: Memo, b: Memo) =>
      a.groupId !== b.groupId
        ? a.groupId > b.groupId
          ? 1
          : -1
        : a.id > b.id
        ? 1
        : -1
    );

    const popupMemo = this.props.allMemos.find(
      memo => memo.id === this.state.popupMemoId
    );

    return (
      <div id="MemoIndex">
        {this.renderHeader()}

        <div id="Memos">
          {memos.length ? (
            <div>
              {memos.map(memo => (
                <MemoItem
                  key={memo.id}
                  memo={memo}
                  group={
                    this.props.groups.find(
                      group => group.id === memo.groupId
                    ) as Group
                  }
                  groups={this.props.groups}
                  members={this.props.members}
                  account={this.props.account}
                  updateMemo={this.props.updateMemo}
                  destroyMemo={this.props.destroyMemo}
                  togglePopup={this.showPopup}
                />
              ))}
            </div>
          ) : (
            <div id="NoMemo">メモがありません</div>
          )}
        </div>

        {this.state.doesShowPopup && popupMemo !== undefined ? (
          <div id="PopupMemo">
            <div className="Delete" onClick={this.hidePopup}>
              <img src={Cancel} />
            </div>
            <div id="PopupMemoItem">
              <MemoItem
                memo={popupMemo}
                group={
                  this.props.groups.find(
                    group => group.id === popupMemo.groupId
                  ) as Group
                }
                groups={this.props.groups}
                members={this.props.members}
                account={this.props.account}
                updateMemo={this.props.updateMemo}
                destroyMemo={this.props.destroyMemo}
                togglePopup={this.showPopup}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  renderHeader() {
    const days = [];
    for (let i = -7; i < 14; i++) {
      const day =
        1000 *
        moment()
          .add(i, 'days')
          .hour(0)
          .minute(0)
          .second(0)
          .unix();
      days.push(day);
    }
    return (
      <div>
        <Navigation group="次の報告日" />

        <div id="NavigationFunction">
          <div />
          <div id="NavigationFunctionRight">
            <select id="FilterByDeadline" onChange={this.onChangeDeadline}>
              {days.map(day => (
                <option value={day} selected={this.state.deadline === day}>
                  {Utility.dateFormat(new Date(day), 'MM日dd日')}
                </option>
              ))}
            </select>
            <OtherActions
              account={this.props.account}
              memos={this.props.memos}
              members={this.props.members}
              updateMemos={this.props.updateMemos}
            />
          </div>
        </div>
      </div>
    );
  }

  showPopup(memoId: number) {
    const memo = new Memo();
    memo.id = memoId;
    this.props.readMemo(memo);
    this.setState({
      doesShowPopup: true,
      popupMemoId: memoId
    });
  }

  hidePopup(e: any) {
    this.setState({
      doesShowPopup: false,
      popupMemoId: 0
    });
  }

  onChangeDeadline(e: any) {
    const deadline = Number(e.target.value);
    this.props.truncateMemos();
    this.props.readMemosByDeadline(deadline);
    this.setState({
      deadline
    });
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  account: state.Account,
  groups: state.Group,
  members: state.Member,
  memos: state.Memo,
  allMemos: state.Memo
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    readMemo(memo: Memo) {
      dispatch(readMemo(memo));
    },
    updateMemo(memo: Memo) {
      dispatch(updateMemo(memo));
    },
    updateMemos(memos: Memo[]) {
      dispatch(updateMemos(memos));
    },
    destroyMemo(memo: Memo) {
      dispatch(destroyMemo(memo));
    },
    readMemosByDeadline(deadline: number) {
      dispatch(readMemosByDeadline(deadline));
    },
    truncateMemos() {
      dispatch(truncateMemos());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemoComponent);



// WEBPACK FOOTER //
// ./src/components/Memo/deadline.tsx